import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter8_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist ein zentrales Ziel der NIS2-Richtlinie?",
      options: [
        {
          value: "A",
          label:
            "Die Verbesserung der Cybersecurity kritischer Sektoren durch harmonisierte Anforderungen in der EU.",
        },
        {
          value: "B",
          label:
            "Die ausschließliche Überwachung von Finanzdienstleistern und Banken.",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Welche Unternehmen fallen unter die NIS2-Richtlinie?",
      options: [
        {
          value: "A",
          label:
            "Unternehmen aus kritischen Sektoren wie Energie, Gesundheitswesen, Transport und IT-Dienstleistungen.",
        },
        {
          value: "B",
          label:
            "Nur große internationale Konzerne, die in der gesamten EU tätig sind.",
        },
      ],
      correct: "A",
    },
  ];


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

  
    return () => unsubscribe();
  }, [navigate]);

 
  useEffect(() => {
    console.log("Aktuelle userId in 8_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
     
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

       
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "8_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("8_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 8_2.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "8_2",
              completedChapters: ["8_2"],
            });
          console.log("Dokument erstellt mit Kapitel 8_2");
        }

        navigate("/cybersecurity/8_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  8. Regulatorische Anforderungen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                NIS2
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 8: Regulatorische Anforderungen
          </h3>

          <img
            src="/images/nis.png"
            alt="nis2"
            style={{ position: "relative", maxWidth: "18%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Was ist NIS2? </h2>
          <p className="col-lg-11 pb-5 mx-auto">
            Während KRITIS die spezifischen Anforderungen und Standards für den
            Schutz nationaler Infrastrukturen in Deutschland vorgibt, will NIS2
            (Network and Information Systems Directive 2) ein hohes und
            einheitliches Niveau der Cybersecurity für kritische Infrastrukturen
            und wesentliche Dienste in der EU erreichen.
            <br />
            <br />
            Die NIS2-Richtlinie ist die Weiterentwicklung der ursprünglichen
            NIS-Richtlinie von 2016 und ein zentraler Bestandteil der
            EU-Strategie zur Verbesserung der Cybersecurity. Diese Richtlinie
            legt strengere und umfassendere Anforderungen an die
            Informationssicherheit für Unternehmen und Organisationen fest, die
            als wesentliche und wichtige Einrichtungen gelten. Ziel ist es, die
            Widerstandsfähigkeit gegenüber Cyberbedrohungen zu stärken und die
            Sicherheit kritischer Infrastrukturen zu verbessern.
            <br />
            <br />
          </p>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="col-lg-11 p-5 text-center mx-auto">
                  Erweiterter Anwendungsbereich
                </h2>

                <p className="col-lg-11 pb-5 text-center mx-auto">
                  Die NIS2-Richtlinie unterscheidet zwischen wesentlichen und
                  wichtigen Einrichtungen, um den unterschiedlichen Einfluss und
                  die Bedeutung von Organisationen auf die Gesellschaft zu
                  berücksichtigen. Beide Kategorien unterliegen
                  Sicherheitsanforderungen, jedoch mit unterschiedlicher
                  Intensität und Aufsicht.
                  <br />
                  <br />
                  Die Unterscheidung basiert auf der Bedeutung der
                  Dienstleistungen, den potenziellen Auswirkungen eines
                  Ausfalls und der Größe oder Marktstellung der Organisation.
                  Während wesentliche Einrichtungen als unverzichtbar für das
                  Funktionieren der Gesellschaft gelten, sind wichtige
                  Einrichtungen ebenfalls relevant, jedoch mit geringerem
                  systemischen Risiko.
                </p>
                <table
                  class="table table-striped table-bordered table-hover table-responsive
                 mb-5  custom-table"
                >
                  <thead>
                    <tr>
                      <th scope="col">Kategorie</th>
                      <th scope="col">Beschreibung</th>
                      <th scope="col">Beispiele</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Wesentliche Einrichtungen</th>
                      <td>
                        Organisationen, deren Ausfall oder Beeinträchtigung
                        erhebliche systemische Auswirkungen auf die Gesellschaft
                        oder Wirtschaft haben könnte. Stehen unter strengerer
                        behördlicher Aufsicht und müssen umfangreichere
                        Sicherheitsanforderungen erfüllen.
                      </td>
                      <td>
                        <strong>Energie:</strong> Strom- und Gasversorgung sowie
                        erneuerbare Energien
                        <br />
                        <br />
                        <strong>Gesundheitswesen:</strong> Krankenhäuser,
                        Forschungseinrichtungen und Hersteller von
                        Medizinprodukten
                        <br />
                        <br />
                        <strong>Finanzwesen:</strong> Banken, Versicherungen und
                        Zahlungsdienstleister
                        <br />
                        <br />
                        <strong>Transportwesen:</strong> Luft-, See-, Schienen-
                        und Straßenverkehr
                        <br />
                        <br />
                        <strong>IT-Dienstleistungen:</strong> Cloud-Anbieter,
                        Rechenzentren und Softwareentwickler
                        <br />
                        <br />
                        <strong>Öffentliche Verwaltung:</strong> Zentralbehörden
                        und regionale Verwaltungseinheiten
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Wichtige Einrichtungen</th>
                      <td>
                        Organisationen, die ebenfalls eine zentrale Rolle
                        spielen, deren Beeinträchtigung jedoch weniger
                        weitreichende Folgen hätte. Unterliegen geringeren
                        regulatorischen Anforderungen.
                      </td>
                      <td>
                        <strong>IT-Sektor-Unternehmen, </strong>
                        <br />

                        <strong>Spezialisierte Cloud-Dienstleister, </strong>
                        <br />

                        <strong>
                          Bestimmte Unternehmen der Lebensmittelindustrie
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die Einhaltung der NIS2-Richtlinie stellt insbesondere für die
                  Finanzbranche eine Herausforderung dar. Banken, Versicherungen
                  und Zahlungsverkehrsdienstleister sind besonders betroffen, da sie als
                  "wesentliche Einrichtungen" gelten. Diese Unternehmen müssen
                  ihre Risikomanagement-Systeme erweitern und zusätzliche
                  Sicherheitsvorkehrungen treffen, um den strengen Vorgaben zu
                  entsprechen. Zusätzlich müssen sie Meldepflichten nachkommen
                  und Sicherheitsvorfälle zeitnah an die zuständigen
                  Aufsichtsbehörden melden.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">Ziele der NIS2-Richtlinie</h3>
                <p className="col-lg-11 mx-auto">
                  Die Richtlinie verfolgt mehrere Ziele, um das allgemeine
                  Sicherheitsniveau in der EU zu erhöhen: <br /> <br />{" "}
                </p>
                <p className="col-lg-10 text-start mx-auto">
                  <ul>
                    <li>
                      <strong>Verbesserte Risikomanagement-Systeme: </strong>{" "}
                      <br />
                      Unternehmen müssen ein Risikomanagement implementieren mit
                      einer umfassenden Strategien zur Identifikation, Bewertung
                      und Bewältigung von IT-Risiken. <br /> <br />
                    </li>
                    <li>
                      <strong>Technische Maßnahmen: </strong> <br />
                      Die Nutzung von Technologien wie{" "}
                      <Link to="/cybersecurity/4_3#firewall" className="icon-link">
                        <svg className="bi" aria-hidden="true">
                          <use xlinkHref="#book"></use>
                        </svg>{" "}
                        Firewalls,
                      </Link>
                      , Verschlüsselung und Intrusion Detection Systems ist
                      verpflichtend. <br /> <br />
                    </li>
                    <li>
                      <strong>Lieferkettensicherheit: </strong> <br />
                      Eine neue Aufgabe für die Unternehmen ist es die Sicherheit
                      in der Lieferkette und die Überwachung von Drittanbietern
                      zu generieren. <br /> <br />
                    </li>
                    <li>
                      <strong>Erhöhte Meldepflichten: </strong> <br />
                      Sicherheitsvorfälle müssen innerhalb von 24 Stunden
                      gemeldet werden, gefolgt von einem detaillierten Bericht
                      innerhalb von 72 Stunden. <br /> <br />
                    </li>
                    <li>
                      <strong>Vorfallmanagement: </strong> <br />
                      Verpflichtende Einrichtung von Prozessen zur schnellen
                      Reaktion auf IT-Sicherheitsvorfälle. <br /> <br />
                    </li>
                    <li>
                      <strong>Stärkung der Zusammenarbeit: </strong> <br />
                      Es wird eine engere Zusammenarbeit zwischen den
                      EU-Mitgliedstaaten gefordert, um Cyberbedrohungen
                      gemeinsam zu bekämpfen und Informationen über Risiken
                      auszutauschen. <br /> <br />
                    </li>
                    <li>
                      <strong>Mitarbeiter- und Führungskräfteschulung: </strong>{" "}
                      <br />
                      Verpflichtende regelmäßige Trainings, um das Bewusstsein
                      für Cybersecuritysrisiken zu erhöhen.
                    </li>
                  </ul>
                </p>
                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die Nichteinhaltung der NIS2-Richtlinien hat schwerwiegende
                  Folgen. Unternehmen riskieren hohe Bußgelder, die von den
                  zuständigen Behörden verhängt werden, sowie
                  Reputationsschäden, die das Vertrauen von Kunden und Partnern
                  nachhaltig beeinträchtigen können. Verstöße führen zudem zu
                  verstärkter behördlicher Aufsicht mit zusätzlichem
                  Kontrollaufwand und steigenden Betriebskosten. In extremen
                  Fällen droht der Entzug der Betriebserlaubnis, wenn
                  grundlegende Sicherheitsanforderungen wiederholt missachtet
                  werden. Die Einhaltung der Richtlinien ist daher entscheidend,
                  um rechtliche, finanzielle und betriebliche Risiken zu
                  minimieren.
                </p>
              </div>
            </div>
          </div>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h3 className="p-5">
                  Herausforderungen bei der Umsetzung der Lieferkettensicherheit
                </h3>
                <p className="col-lg-11 mx-auto">
                  Die Sicherheit in der Lieferkette und die Überwachung von
                  Drittanbietern sind zentrale Aspekte der NIS2-Richtlinie.
                  Unternehmen, insbesondere Betreiber kritischer
                  Infrastrukturen, sind oft stark von externen
                  IT-Dienstleistern, Cloud-Anbietern und Lieferanten abhängig.
                  Diese Abhängigkeit erhöht das Risiko, dass Schwachstellen in
                  der Lieferkette zu Sicherheitsvorfällen führen.
                  <br />
                  <br />
                  Die NIS2-Richtlinie fordert daher, dass Unternehmen ihre
                  Lieferketten systematisch auf Sicherheitsrisiken überprüfen
                  und entsprechende Maßnahmen ergreifen. Dazu gehören:
                  <br />
                  <br />
                  <strong>1. Sicherheitsaudits bei Drittanbietern:</strong>{" "}
                  Unternehmen müssen sicherstellen, dass ihre externen Partner
                  die gleichen hohen Sicherheitsstandards einhalten wie sie
                  selbst. Dies kann durch regelmäßige Audits und
                  Zertifizierungen überprüft werden. 
                  <br />
                  <br />
                  <strong>2. Vertragliche Sicherheitsanforderungen: </strong>
                  Die NIS2-Richtlinie verlangt, dass Unternehmen sicherstellen,
                  dass auch ihre Drittanbieter strikte Sicherheitsvorgaben
                  umsetzen. Dazu gehören Maßnahmen wie die Implementierung von
                  Firewalls, die Verschlüsselung sensibler Daten und die
                  Kontrolle des Zugriffs auf kritische Systeme. Externe
                  Dienstleister müssen geeignete Schutzmaßnahmen ergreifen, um
                  die Vertraulichkeit, Integrität und Verfügbarkeit der Daten
                  ihrer Auftraggeber zu gewährleisten. Diese Vorgaben minimieren
                  das Risiko, dass Schwachstellen in der Lieferkette die gesamte
                  Sicherheitsinfrastruktur des Unternehmens gefährden.
                  <br />
                  <br />
                  <strong>
                    3. Risikomanagement für die gesamte Lieferkette
                  </strong>{" "}
                  Unternehmen müssen ein umfassendes Risikomanagementsystem für
                  die Lieferkette etablieren, das die Identifizierung und
                  Bewertung von Risiken im Zusammenhang mit Drittanbietern
                  einschließt. Hierzu gehört die Analyse potenzieller
                  Bedrohungen, die durch Zulieferer und Partnerunternehmen
                  entstehen könnten, sowie die Entwicklung von Maßnahmen zur
                  Risikominimierung und ein Notfallplan für die Lieferkette. Ein
                  solches Risikomanagementsystem soll sicherstellen, dass das
                  Unternehmen jederzeit die Kontrolle über die Sicherheit seiner
                  Lieferkette behält und mögliche Schwachstellen proaktiv
                  adressiert.
                  <br />
                  <br />
                  <strong>4. Kontinuierliches Monitoring:</strong> Eine laufende
                  Überwachung von Drittanbietern hilft, neue Risiken frühzeitig
                  zu erkennen und zu adressieren. Dies kann durch den Einsatz
                  von Technologien wie{" "}
                  <Link to="/cybersecurity/4_3#siem" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    SIEM (Security Information and Event Management)
                  </Link>{" "}
                  unterstützt werden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="col-lg-11 p-5 text-center mx-auto">
              Vergleich Vergleich von KRITIS und NIS2 und deren Relevanz für den
              Finanzsektor
            </h3>
            <p className="col-lg-11 mx-auto">
              Während KRITIS die spezifischen Anforderungen und Standards für
              den Schutz nationaler Infrastrukturen in Deutschland vorgibt,
              schafft NIS2 eine EU-weite Harmonisierung und erleichtert die
              internationale Zusammenarbeit im Bereich der Cybersecurity. Für
              den Finanzsektor bieten beide Regelwerke eine strukturierte
              Grundlage, um die Sicherheit der Systeme zu verbessern und die
              Resilienz gegenüber Cyberbedrohungen zu stärken.
              <br />
              <br />
              KRITIS und NIS2 sind beide darauf ausgerichtet, kritische
              Infrastrukturen gegen Cyberangriffe zu schützen, aber sie haben
              unterschiedliche Schwerpunkte und Reichweiten:
            </p>
            <div className="row">
              <table
                class="table table-striped table-bordered table-hover table-responsive
                 custom-table"
              >
                <thead>
                  <tr>
                    <th>Kriterium</th>
                    <th>KRITIS</th>
                    <th>NIS2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <strong>Ziel und Geltungsbereich</strong>
                    </td>
                    <td>
                      Deutsches Rahmenwerk für die Sicherheit kritischer
                      Infrastrukturen, einschließlich des Finanzsektors; richtet
                      sich an nationale Infrastrukturen.
                    </td>
                    <td>
                      EU-Richtlinie zur Verbesserung der Cybersecurity in allen
                      Mitgliedstaaten und Sektoren, darunter auch die
                      Finanzbranche; erweiterter Schutz für mehr Organisationen.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Sicherheitsanforderungen</strong>
                    </td>
                    <td>
                      Technische und organisatorische Maßnahmen, die auf
                      deutsche Standards abgestimmt sind; regelmäßige Audits und
                      Sicherheitsmanagementsysteme für Finanzdienstleister.
                    </td>
                    <td>
                      Harmonisierte Cybersecuritysstandards für alle
                      EU-Mitgliedstaaten; Risikoanalysen und Schutzmaßnahmen für
                      die gesamte Lieferkette.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Vorfallmeldungen und Krisenmanagement</strong>
                    </td>
                    <td>
                      Pflicht zur Meldung sicherheitsrelevanter Vorfälle an das
                      BSI; schnelle Koordination und Reaktion auf nationale
                      Vorfälle im Finanzsektor.
                    </td>
                    <td>
                      Verpflichtung zur Meldung erheblicher Sicherheitsvorfälle
                      innerhalb von 24 Stunden; Förderung des
                      Informationsaustauschs zwischen Mitgliedstaaten für
                      bessere Zusammenarbeit.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Relevanz für den Finanzsektor</strong>
                    </td>
                    <td>
                      Hohe Relevanz für deutsche Banken und Finanzdienstleister
                      als Teil kritischer Infrastrukturen; nationale Ausrichtung auf
                      spezifische Anforderungen des deutschen Finanzsektors.
                    </td>
                    <td>
                      Einheitliche Cybersecuritysstandards für international
                      tätige Finanzinstitute in der EU; erleichtert
                      grenzüberschreitende Sicherheitsstrategien und erhöht die
                      Resilienz im gesamten Finanzsektor.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter8_2;
